



  <!-- CLOSE BUTTON -->

<div class="training-page">

   <button
    mat-icon-button
    type="button"
    class="training-close-btn"
    (click)="closeTraining()"
    matTooltip="Close">
    <mat-icon>close</mat-icon>
  </button>

  <main class="main-content">

    <!-- TOOLBAR: FILTER + SEARCH -->
    <div class="training-toolbar">

      <mat-form-field appearance="outline" class="video-filter">

        <mat-select [(value)]="selectedVideoFilter" (selectionChange)="onVideoFilterChange($event.value)">

          <!-- <mat-option [value]="0">
            Custom Workflows
          </mat-option> -->

          <mat-option [value]="1">
            All Videos
          </mat-option>

          <mat-option [value]="2">
            Global Videos
          </mat-option>

          <mat-option [value]="3">
            Organization Videos
          </mat-option>

          <mat-option [value]="4">
            Location Videos
          </mat-option>

        </mat-select>

      </mat-form-field>


      <div class="training-search">

        <mat-icon>search</mat-icon>

        <input
          type="text"
          placeholder="Search videos..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()" />

        <button
          *ngIf="searchTerm"
          mat-icon-button
          type="button"
          class="training-search-clear"
          (click)="searchTerm=''; onSearchChange()"
          matTooltip="Clear search">
          <mat-icon>close</mat-icon>
        </button>

      </div>

    </div>


    <!-- WORKFLOW CARD -->
    <div class="workflow-card">

      <!-- HEADER -->
      <div class="workflow-card-header">

        <div class="workflow-heading">

          <span class="heading">
            {{textTile}}
          </span>

          <span class="available">
            {{ getVisibleCount() !== totalCount ? (getVisibleCount() + ' of ' + totalCount + ' available') : (totalCount + ' available') }}
          </span>

        </div>

      </div>


      <!-- CATEGORY LIST -->
      <!-- ================= CUSTOM WORKFLOWS ================= -->
      <div class="workflow-scroll" *ngIf="isGroup == true">

        <div class="workflow-group" *ngFor="let category of filteredCategories; let i = index">

          <!-- CATEGORY HEADER -->
          <div class="group-header" (click)="toggleSection(i)">

            <div class="group-title">

              <mat-icon>
                {{
                expandedSection === i
                ? 'keyboard_arrow_up'
                : 'keyboard_arrow_down'
                }}
              </mat-icon>

              <span>
                {{ category.categoryName }}
              </span>

            </div>

            <div class="group-info">

              <span>
                {{ category.contents.length }}
                {{ category.contents.length === 1 ? 'video' : 'videos' }}
              </span>

              <span class="separator">
                •
              </span>

              <span>
                {{ getDuration(category.durationInSeconds) }}
              </span>

            </div>

          </div>


          <!-- CATEGORY VIDEOS -->
          <div class="video-grid" *ngIf="expandedSection === i">

            <div class="video-card" *ngFor="let content of category.contents" (click)="openVedioLink(content, showVedio)">

              <div class="video-play">

                <mat-icon>
                  play_arrow
                </mat-icon>

              </div>


              <div class="video-content">

                <div class="video-heading">

                  <span class="video-title" [matTooltip]="content.url">
                    {{ content.title }}
                  </span>

                  <span class="video-time">
                    {{ getContentDuration(content.totalDurationSeconds) }}
                  </span>

                </div>


                <div class="video-description" *ngIf="content.description">
                  {{ content.description }}
                </div>

              </div>

            </div>

          </div>

        </div>

        <div class="no-results" *ngIf="filteredCategories.length === 0">
          No videos found{{ searchTerm ? ' for "' + searchTerm + '"' : '' }}.
        </div>

      </div>


      <!-- ================= ALL VIDEOS ================= -->
      <div class="workflow-scroll" *ngIf="isGroup == false">

        <div class="video-grid">

          <div class="video-card" *ngFor="let content of filteredTrainingContentList" (click)="openVedioLink(content, showVedio)">

            <!-- PLAY BUTTON -->
            <div class="video-play">

              <mat-icon>
                play_arrow
              </mat-icon>

            </div>


            <!-- VIDEO CONTENT -->
            <div class="video-content">

              <div class="video-heading">

                <span class="video-title" [matTooltip]="content.url">
                  {{ content.title }}
                </span>

                <span class="video-time">
                  {{ getContentDuration(content.totalDurationSeconds) }}
                </span>

              </div>


              <div class="video-description" *ngIf="content.description">
                {{ content.description }}
              </div>

            </div>

          </div>

        </div>

        <div class="no-results" *ngIf="filteredTrainingContentList.length === 0">
          No videos found{{ searchTerm ? ' for "' + searchTerm + '"' : '' }}.
        </div>

      </div>

    </div>

  </main>

</div>



<!-- VIDEO DIALOG -->
<ng-template #showVedio>

  <h2 mat-dialog-title class="video-dialog-title">
    <span>Preview</span>
    <button mat-icon-button type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

  </h2>


  <mat-dialog-content class="video-dialog-content">

    <div class="video-container">

      <iframe [src]="safeSrcVedio" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
      </iframe>

    </div>

  </mat-dialog-content>


  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">
      Cancel
    </button>
  </mat-dialog-actions>

</ng-template>
